webpackJsonp([213534597649335],{

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';var d=d||{};d.scope={};d.ASSUME_ES5=!1;d.ASSUME_NO_NATIVE_MAP=!1;d.ASSUME_NO_NATIVE_SET=!1;d.defineProperty=d.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(a,c,e){a!=Array.prototype&&a!=Object.prototype&&(a[c]=e.value)};d.getGlobal=function(a){return"undefined"!=typeof window&&window===a?a:"undefined"!=typeof global&&null!=global?global:a};d.global=d.getGlobal(this);d.SYMBOL_PREFIX="jscomp_symbol_";
	d.initSymbol=function(){d.initSymbol=function(){};d.global.Symbol||(d.global.Symbol=d.Symbol)};d.Symbol=function(){var a=0;return function(c){return d.SYMBOL_PREFIX+(c||"")+a++}}();d.initSymbolIterator=function(){d.initSymbol();var a=d.global.Symbol.iterator;a||(a=d.global.Symbol.iterator=d.global.Symbol("iterator"));"function"!=typeof Array.prototype[a]&&d.defineProperty(Array.prototype,a,{configurable:!0,writable:!0,value:function(){return d.arrayIterator(this)}});d.initSymbolIterator=function(){}};
	d.arrayIterator=function(a){var c=0;return d.iteratorPrototype(function(){return c<a.length?{done:!1,value:a[c++]}:{done:!0}})};d.iteratorPrototype=function(a){d.initSymbolIterator();a={next:a};a[d.global.Symbol.iterator]=function(){return this};return a};
	d.iteratorFromArray=function(a,c){d.initSymbolIterator();a instanceof String&&(a+="");var e=0,b={next:function(){if(e<a.length){var f=e++;return{value:c(f,a[f]),done:!1}}b.next=function(){return{done:!0,value:void 0}};return b.next()}};b[Symbol.iterator]=function(){return b};return b};
	d.polyfill=function(a,c){if(c){var e=d.global;a=a.split(".");for(var b=0;b<a.length-1;b++){var f=a[b];f in e||(e[f]={});e=e[f]}a=a[a.length-1];b=e[a];c=c(b);c!=b&&null!=c&&d.defineProperty(e,a,{configurable:!0,writable:!0,value:c})}};d.polyfill("Array.prototype.values",function(a){return a?a:function(){return d.iteratorFromArray(this,function(a,e){return e})}},"es8","es3");function g(a){return a&&"object"===typeof a&&"default"in a?a["default"]:a}
	var h=g(__webpack_require__(21)),k=g(__webpack_require__(12)),l=g(__webpack_require__(30)),m=g(__webpack_require__(42)),n=g(__webpack_require__(8)),p=g(__webpack_require__(41));function q(a){var c=new Intl.DateTimeFormat(a,1<arguments.length&&void 0!==arguments[1]?arguments[1]:{});return function(a){return c.format(a)}}
	function r(a){var c=new Intl.NumberFormat(a,1<arguments.length&&void 0!==arguments[1]?arguments[1]:{});return function(a){return c.format(a)}}
	function t(a){function c(a,c){return function(b){b="function"===typeof c?c(b):c;return(Array.isArray(b)?b:[b]).map(function(c){return"string"===typeof c?c.replace("#",a):c})}}function e(a){return"string"===typeof a?b[a]||{style:a}:a}var b=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},f=(1<arguments.length&&void 0!==arguments[1]?arguments[1]:{}).plurals;return{plural:function(a,b){var e=b.offset;e=void 0===e?0:e;b=h(b,["offset"]);b=b[a]||b[f(a-e)];return c(a-e,b)},selectordinal:function(a,
	b){var e=b.offset;e=void 0===e?0:e;b=h(b,["offset"]);b=b[a]||b[f(a-e,!0)];return c(a-e,b)},select:function(a,c){return c[a]||c.other},number:function(c,b){return r(a,e(b))(c)},date:function(c,b){return q(a,e(b))(c)},undefined:function(a){return a}}}function u(a){var c=a.values,e=t(a.language,a.languageData,a.formats);return function x(a,v,w){a=e[v](c[a],w);a="function"===typeof a?a(x):a;return Array.isArray(a)?a.join(""):a}}
	function y(a,c,e){return function(b){var f=a(u({language:c,languageData:e,formats:1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},values:b}));return Array.isArray(f)?f.join("").trim():f}}
	var A=function(){function a(){n(this,a);this._activeMessages={};this._catalogs={}}p(a,[{key:"_cacheActiveLanguage",value:function(){var a=this._catalogs[this.language],e=(a||{}).languageData||{};this._activeMessages=(a||{}).messages||{};this._activeLanguageData=e}},{key:"load",value:function(a){var c=this;"object"===("undefined"===typeof a?"undefined":m(a))&&(l(k({},this._catalogs,a)).forEach(function(b){c._catalogs[b]={messages:k({},(c._catalogs[b]||{}).messages||{},(a[b]||{}).messages||{}),languageData:k({},
	(c._catalogs[b]||{}).languageData||{},(a[b]||{}).languageData||{})}}),this._cacheActiveLanguage())}},{key:"activate",value:function(a){a&&(this._language=a,this._cacheActiveLanguage())}},{key:"use",value:function(a){return z({language:a,catalogs:this._catalogs,development:this._dev})}},{key:"_",value:function(a){var c=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},b=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},f=b.defaults;b=b.formats;b=void 0===b?{}:b;f=this.messages[a]||
	f||a;return"function"!==typeof f?f:y(f,this.language,this.languageData)(c,b)}},{key:"pluralForm",value:function(a){return this.languageData.plurals?this.languageData.plurals(a,"ordinal"===(1<arguments.length&&void 0!==arguments[1]?arguments[1]:"cardinal")):"other"}},{key:"availableLanguages",get:function(){return l(this._catalogs)}},{key:"language",get:function(){return this._language}},{key:"messages",get:function(){return this._activeMessages}},{key:"languageData",get:function(){return this._activeLanguageData}}]);
	return a}();function z(){var a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},c=new A;a.catalogs&&c.load(a.catalogs);a.language&&c.activate(a.language);return c}var B=z(),C=Object.freeze({i18nMark:function(a){return a},i18n:B,setupI18n:z,date:q,number:r});module.exports=C;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(57)
	} else {
	  module.exports = require("./cjs/core.development.js")
	}


/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';var e=e||{};e.scope={};e.ASSUME_ES5=!1;e.ASSUME_NO_NATIVE_MAP=!1;e.ASSUME_NO_NATIVE_SET=!1;e.defineProperty=e.ASSUME_ES5||"function"==typeof Object.defineProperties?Object.defineProperty:function(a,c,b){a!=Array.prototype&&a!=Object.prototype&&(a[c]=b.value)};e.getGlobal=function(a){return"undefined"!=typeof window&&window===a?a:"undefined"!=typeof global&&null!=global?global:a};e.global=e.getGlobal(this);e.SYMBOL_PREFIX="jscomp_symbol_";
	e.initSymbol=function(){e.initSymbol=function(){};e.global.Symbol||(e.global.Symbol=e.Symbol)};e.Symbol=function(){var a=0;return function(c){return e.SYMBOL_PREFIX+(c||"")+a++}}();e.initSymbolIterator=function(){e.initSymbol();var a=e.global.Symbol.iterator;a||(a=e.global.Symbol.iterator=e.global.Symbol("iterator"));"function"!=typeof Array.prototype[a]&&e.defineProperty(Array.prototype,a,{configurable:!0,writable:!0,value:function(){return e.arrayIterator(this)}});e.initSymbolIterator=function(){}};
	e.arrayIterator=function(a){var c=0;return e.iteratorPrototype(function(){return c<a.length?{done:!1,value:a[c++]}:{done:!0}})};e.iteratorPrototype=function(a){e.initSymbolIterator();a={next:a};a[e.global.Symbol.iterator]=function(){return this};return a};
	e.iteratorFromArray=function(a,c){e.initSymbolIterator();a instanceof String&&(a+="");var b=0,d={next:function(){if(b<a.length){var f=b++;return{value:c(f,a[f]),done:!1}}d.next=function(){return{done:!0,value:void 0}};return d.next()}};d[Symbol.iterator]=function(){return d};return d};
	e.polyfill=function(a,c){if(c){var b=e.global;a=a.split(".");for(var d=0;d<a.length-1;d++){var f=a[d];f in b||(b[f]={});b=b[f]}a=a[a.length-1];d=b[a];c=c(d);c!=d&&null!=c&&e.defineProperty(b,a,{configurable:!0,writable:!0,value:c})}};e.polyfill("Array.prototype.values",function(a){return a?a:function(){return e.iteratorFromArray(this,function(a,b){return b})}},"es8","es3");function h(a){return a&&"object"===typeof a&&"default"in a?a["default"]:a}
	var l=h(__webpack_require__(97)),n=h(__webpack_require__(8)),p=h(__webpack_require__(41)),q=h(__webpack_require__(22)),r=h(__webpack_require__(20)),t=__webpack_require__(1),u=h(__webpack_require__(2)),w=h(__webpack_require__(12)),y=h(__webpack_require__(91)),z=__webpack_require__(58),B=h(__webpack_require__(61)),C=h(__webpack_require__(98)),
	D=h(__webpack_require__(30)),E=h(__webpack_require__(21)),F=function(a){function c(){n(this,c);return q(this,(c.__proto__||l(c)).apply(this,arguments))}r(c,a);p(c,[{key:"render",value:function(){var b=this.props,a=b.className;b=b.value;var c=this.props.render||this.context.linguiDefaultRender;return null===c||void 0===c?b:"string"===typeof c?t.createElement(c,{className:a},b):t.isValidElement(c)?t.cloneElement(c,{},b):t.createElement(c,{translation:b})}}]);
	return c}(t.Component);F.contextTypes={linguiDefaultRender:u.any};function J(a){return function(c){var b=c.value,d=c.className,f=c.render;c=a(c.i18n.language,c.format);return t.createElement(F,{className:d,render:f,value:c(b)})}}
	function K(){var a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return function(c){var b=a.update,d=void 0===b?!0:b;b=a.withHash;var f=void 0===b?!0:b;b=a.withRef;var g=void 0===b?!1:b;b=function(a){function b(){var a,c,d,f;n(this,b);for(var v=arguments.length,m=Array(v),k=0;k<v;k++)m[k]=arguments[k];return f=(c=(d=q(this,(a=b.__proto__||l(b)).call.apply(a,[this].concat(m))),d),d.wrappedInstance=null,d.setWrappedInstance=function(b){g&&(d.wrappedInstance=b)},d.getWrappedInstance=function(){if(!g)throw Error("To access the wrapped instance, you need to specify { withRef: true } in the options argument of the withI18n() call.");
	return d.wrappedInstance},d.checkUpdate=function(){d.forceUpdate()},c),q(d,f)}r(b,a);p(b,[{key:"componentDidMount",value:function(){var b=this.getI18n().subscribe;d&&b&&b(this.checkUpdate)}},{key:"componentWillUnmount",value:function(){var b=this.getI18n().unsubscribe;d&&b&&b(this.checkUpdate)}},{key:"getI18n",value:function(){return this.context.linguiPublisher||{}}},{key:"render",value:function(){var b=this.getI18n(),a=b.i18n;b=b.i18nHash;b=w({},this.props,g?{ref:this.setWrappedInstance}:{},f?{i18nHash:b}:
	{});return t.createElement(c,w({},b,{i18n:a}))}}]);return b}(t.Component);b.contextTypes={linguiPublisher:u.object};return b}}
	function L(a){var c=[];return{i18n:a,i18nHash:null,getSubscribers:function(){return c},subscribe:function(b){c.push(b)},unsubscribe:function(b){c=c.filter(function(a){return a!==b})},update:function(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},d=b.catalogs;b=b.language;if(d||b)d&&a.load(d),b&&a.activate(b),this.i18nHash=y([a.language,a.messages]),c.forEach(function(b){return b()})}}}
	var M=function(a){function c(b){n(this,c);var a=q(this,(c.__proto__||l(c)).call(this,b)),f=b.language,g=b.catalogs;b=b.i18n||z.setupI18n({language:f,catalogs:g});a.linguiPublisher=new L(b);return a}r(c,a);p(c,[{key:"componentDidUpdate",value:function(b){var a=this.props,c=a.language;a=a.catalogs;c===b.language&&a===b.catalogs||this.linguiPublisher.update({language:c,catalogs:a})}},{key:"getChildContext",value:function(){return{linguiPublisher:this.linguiPublisher,linguiDefaultRender:this.props.defaultRender}}},
	{key:"render",value:function(){return t.createElement(t.Fragment,null,this.props.children)}}]);return c}(t.Component);M.defaultProps={defaultRender:null};M.childContextTypes={linguiPublisher:u.object.isRequired,linguiDefaultRender:u.any};var N=/<(\d+)>(.*)<\/\1>|<(\d+)\/>/,O=/(?:\r\n|\r|\n)/g;
	function P(a){var c=1<arguments.length&&void 0!==arguments[1]?arguments[1]:[],b=a.replace(O,"").split(N);if(1===b.length)return a;var d=[],f=b.shift();f&&d.push(f);f=!0;var g=!1,k=void 0;try{for(var v=B(Q(b)),G;!(f=(G=v.next()).done);f=!0){var A=C(G.value,3),H=A[0],I=A[1],x=A[2];d.push(t.cloneElement(c[H],{key:H},I?P(I,c):null));x&&d.push(x)}}catch(m){g=!0,k=m}finally{try{!f&&v.return&&v.return()}finally{if(g)throw k;}}return d}
	function Q(a){if(!a.length)return[];var c=a.slice(0,4);c=C(c,4);var b=c[1],d=c[2],f=c[3];return[[parseInt(c[0]||d),b||"",f]].concat(Q(a.slice(4,a.length)))}
	var R=function(a){function c(){n(this,c);return q(this,(c.__proto__||l(c)).apply(this,arguments))}r(c,a);p(c,[{key:"componentDidMount",value:function(){}},{key:"getTranslation",value:function(){var b=this.props,a=b.id;a=void 0===a?"":a;var c=b.defaults,g=b.i18n,k=b.values;b=b.formats;return g&&"function"===typeof g._?g._(a,k,{defaults:c,formats:b}):a}},{key:"render",value:function(){var a=P(this.getTranslation(),this.props.components);return t.createElement(F,{render:this.props.render,className:this.props.className,
	value:a})}}]);return c}(t.Component),S=K()(R),T=K()(function(a){function c(){n(this,c);return q(this,(c.__proto__||l(c)).apply(this,arguments))}r(c,a);p(c,[{key:"render",value:function(){var a=this.props,c=a.className,f=a.render,g=a.i18n;a=E(a,["className","render","i18n"]);return t.createElement(F,{className:c,render:f,value:g.select(a)})}}]);return c}(t.Component));
	function U(){var a,c,b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:!1,d=b?"SelectOrdinal":"Plural",f=b?"selectOrdinal":"plural";return c=a=function(a){function b(){var a,c,f,g;n(this,b);for(var k=arguments.length,x=Array(k),m=0;m<k;m++)x[m]=arguments[m];return g=(c=(f=q(this,(a=b.__proto__||l(b)).call.apply(a,[this].concat(x))),f),f.displayName=d,c),q(f,g)}r(b,a);p(b,[{key:"render",value:function(){var a=this.props,b=a.className,c=a.render,d=a.i18n,g=a.value,k=a.offset,m=E(a,["className",
	"render","i18n","value","offset"]);a=D(m).reduce(function(a,b){var c=b.replace("_","");a[c]=m[b];return a},{value:parseInt(g),offset:parseInt(k)});return t.createElement(F,{className:b,render:c,value:d[f](a)})}}]);return b}(t.Component),a.defaultProps={offset:0},c}var V=K()(U(!1)),W=K()(U(!0)),X=K()(J(z.date)),Y=K()(J(z.number)),Z=Object.freeze({withI18n:K,DateFormat:X,NumberFormat:Y,i18nMark:function(a){return a},I18nProvider:M,Trans:S,Plural:V,Select:T,SelectOrdinal:W});module.exports=Z;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(59)
	} else {
	  module.exports = require("./cjs/react.development.js")
	}


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(8);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(22);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(20);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(21);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(12);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	'use strict';
	
	function pad (hash, len) {
	  while (hash.length < len) {
	    hash = '0' + hash;
	  }
	  return hash;
	}
	
	function fold (hash, text) {
	  var i;
	  var chr;
	  var len;
	  if (text.length === 0) {
	    return hash;
	  }
	  for (i = 0, len = text.length; i < len; i++) {
	    chr = text.charCodeAt(i);
	    hash = ((hash << 5) - hash) + chr;
	    hash |= 0;
	  }
	  return hash < 0 ? hash * -2 : hash;
	}
	
	function foldObject (hash, o, seen) {
	  return Object.keys(o).sort().reduce(foldKey, hash);
	  function foldKey (hash, key) {
	    return foldValue(hash, o[key], key, seen);
	  }
	}
	
	function foldValue (input, value, key, seen) {
	  var hash = fold(fold(fold(input, key), toString(value)), typeof value);
	  if (value === null) {
	    return fold(hash, 'null');
	  }
	  if (value === undefined) {
	    return fold(hash, 'undefined');
	  }
	  if (typeof value === 'object') {
	    if (seen.indexOf(value) !== -1) {
	      return fold(hash, '[Circular]' + key);
	    }
	    seen.push(value);
	    return foldObject(hash, value, seen);
	  }
	  return fold(hash, value.toString());
	}
	
	function toString (o) {
	  return Object.prototype.toString.call(o);
	}
	
	function sum (o) {
	  return pad(foldValue(0, o, '', []).toString(16), 8);
	}
	
	module.exports = sum;


/***/ }),

/***/ 134:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FeaturesFragment = exports.FeatureLinks = exports.Feature = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _react2 = __webpack_require__(19);
	
	var _gatsbyLink = __webpack_require__(54);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(87);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hyphenToCamelCase = function hyphenToCamelCase(s) {
	  return s.replace(/-([a-z])/g, function (g) {
	    return g[1].toUpperCase();
	  });
	};
	
	var Feature = exports.Feature = function Feature(props) {
	  return React.createElement(
	    'div',
	    { className: 'row align-items-center' },
	    React.createElement(
	      'div',
	      { className: 'col-md-5 ml-auto' },
	      React.createElement(
	        'h2',
	        null,
	        props.title || props.name
	      ),
	      React.createElement(
	        'p',
	        null,
	        props.children
	      ),
	      React.createElement(
	        'p',
	        null,
	        React.createElement(
	          _gatsbyLink2.default,
	          { href: true, to: '#try' },
	          React.createElement(_react2.Trans, {
	            id: 'Learn more about'
	          }),
	          ' ',
	          props.name
	        )
	      )
	    ),
	    React.createElement(
	      'div',
	      { className: 'col-md-5 ml-md-auto ' + (props.left ? 'order-md-first' : '') },
	      React.createElement(_gatsbyImage2.default, _extends({}, props.data[hyphenToCamelCase(props.url)], { alt: props.name }))
	    )
	  );
	};
	Feature.defaultProps = {
	  title: '',
	  left: false
	};
	
	var FeatureLink = function FeatureLink(props) {
	  return props.page !== props.url && React.createElement(
	    'div',
	    { className: 'col-6 px-3 col-lg-3' },
	    React.createElement(
	      _gatsbyLink2.default,
	      { href: true, to: props.url },
	      React.createElement(
	        'div',
	        { className: 'card border hover-shadow-8' },
	        React.createElement(
	          'div',
	          { className: 'card-body mb-0 pb-0 px-2 h-125' },
	          React.createElement(
	            'h6',
	            { className: 'card-title text-center' },
	            props.name
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'mx-auto', style: { height: '8rem', width: '8rem' } },
	          React.createElement(_gatsbyImage2.default, _extends({
	            className: 'card-img-bottom'
	          }, props.data[hyphenToCamelCase(props.img)], {
	            alt: props.name,
	            style: { maxHeight: '100%', maxWidth: '100%' }
	          }))
	        )
	      )
	    )
	  );
	};
	
	var FeatureLinks = function FeatureLinks(_ref) {
	  var i18n = _ref.i18n,
	      props = _objectWithoutProperties(_ref, ['i18n']);
	
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      'header',
	      { className: 'section-header ' },
	      React.createElement('hr', { className: 'mt-7 mb-5' }),
	      React.createElement(
	        'h2',
	        null,
	        props.page === 'index' ? React.createElement(_react2.Trans, {
	          id: 's2_link'
	        }) : React.createElement(_react2.Trans, {
	          id: 'Discover more about Focus Tax Solutions'
	        })
	      )
	    ),
	    React.createElement(
	      'div',
	      { className: 'row gap-y' },
	      React.createElement(FeatureLink, _extends({}, props, { name: i18n._('s2_feature1'), img: 'round-modeling', url: '#references' })),
	      React.createElement(FeatureLink, _extends({}, props, { name: i18n._('s2_feature2'), img: 'esop', url: '#references' })),
	      React.createElement(FeatureLink, _extends({}, props, { name: i18n._('s2_feature3'), img: 'reporting', url: '#references' })),
	      React.createElement(FeatureLink, _extends({}, props, { name: i18n._('s2_feature4'), img: 'investors', url: '#references' }))
	    )
	  );
	};
	
	// eslint-disable-next-line no-undef
	exports.FeatureLinks = FeatureLinks;
	var FeaturesFragment = exports.FeaturesFragment = '** extracted graphql fragment **';

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Reference = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _gatsbyImage = __webpack_require__(87);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Reference = exports.Reference = function Reference(props) {
	  return React.createElement(
	    'div',
	    { style: { width: props.width || '200px' }, className: 'my-4' },
	    React.createElement(_gatsbyImage2.default, _extends({}, props.img, { alt: props.name }))
	  );
	};
	
	exports.default = Reference;

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _react2 = __webpack_require__(19);
	
	var _gatsbyImage = __webpack_require__(87);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Features = __webpack_require__(147);
	
	var _Reference = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Header = function Header(_ref) {
	  var i18n = _ref.i18n,
	      data = _ref.data;
	  return React.createElement(
	    'header',
	    { className: 'header bg-ledgy pb-0' },
	    React.createElement(
	      'div',
	      { className: 'container', id: 'start' },
	      React.createElement(
	        'div',
	        { className: 'row align-items-end gap-y mt-5 pb-7' },
	        React.createElement(
	          'div',
	          { className: 'col-lg-6 ml-auto' },
	          React.createElement(
	            'div',
	            { className: 'mb-4 text-white' },
	            React.createElement(
	              'h1',
	              null,
	              React.createElement(_react2.Trans, {
	                id: 's1_title'
	              })
	            ),
	            React.createElement(
	              'p',
	              null,
	              React.createElement(_react2.Trans, {
	                id: 's1_p1'
	              }),
	              React.createElement('br', null),
	              React.createElement('br', null),
	              React.createElement(_react2.Trans, {
	                id: 's1_p2'
	              })
	            )
	          ),
	          React.createElement(
	            'a',
	            { className: 'btn btn-block d-sm-inline btn-xl mx-1 btn-round btn-outline-light', href: '#references', target: '_blank', rel: 'noopener noreferrer' },
	            React.createElement(_react2.Trans, {
	              id: 's2_title'
	            })
	          ),
	          React.createElement(
	            'a',
	            { className: 'btn btn-block d-sm-inline btn-xl mx-1 btn-round btn-light', href: '#try' },
	            React.createElement(_react2.Trans, {
	              id: 's3_link'
	            })
	          )
	        ),
	        React.createElement(
	          'div',
	          { className: 'col-lg-6 order-lg-first' },
	          React.createElement(_gatsbyImage2.default, _extends({}, data.laptop, { alt: i18n._('Focus tax solutions') }))
	        )
	      )
	    )
	  );
	};
	
	var IndexPage = function IndexPage(props) {
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(Header, props),
	    React.createElement(
	      'main',
	      { className: 'main-content' },
	      React.createElement(
	        'section',
	        { className: 'section py-7', id: 'references' },
	        React.createElement(
	          'div',
	          { className: 'container' },
	          React.createElement(
	            'header',
	            { className: 'section-header mb-3' },
	            React.createElement(
	              'h2',
	              null,
	              React.createElement(_react2.Trans, {
	                id: 's2_title1'
	              })
	            ),
	            React.createElement('hr', { className: 'my-2' })
	          ),
	          React.createElement(
	            'div',
	            { className: 'partner' },
	            React.createElement(_Reference.Reference, { img: props.data.cpa, name: 'cpa' }),
	            React.createElement(_Reference.Reference, { img: props.data.ipa, name: 'ipa', width: '400px' })
	          ),
	          React.createElement(_Features.FeatureLinks, _extends({}, props, { page: 'index' }))
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _react2.withI18n)()(IndexPage);
	
	// eslint-disable-next-line no-undef
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-09b7d798a76b810b8354.js